import "./BoardBar.scss"
import React from "react"

export default function BoardBar() {
  return <nav className="navbar-board">Board bar</nav>
}
